// Types for Uber Rides (db/migrations/5600). Every figure, label and refusal
// comes from Postgres; this file only names the shapes.
export type RiderKind = 'driver' | 'owner'
export type CarriedBy = 'fleetly' | 'driver' | 'owner'
export type RideStatus = 'booked' | 'cancelled'

export type RideReason = { value: string; label: string; rider: RiderKind | null }

export type RideOptions = {
  can_log: boolean
  is_admin: boolean
  now: string
  reasons: RideReason[]
  drivers: { id: string; name: string; status: string; phone: string | null; last_vehicle_id: string | null }[]
  owners: { id: string; name: string; status: string; phone: string | null; vehicle_ids: string[] }[]
  vehicles: { id: string; owner_id: string | null; label: string }[]
}

export type Ride = {
  id: string; ref: string; status: RideStatus
  rider_kind: RiderKind; rider_name: string | null; driver_id: string | null; owner_id: string | null
  vehicle: string | null
  reason_kind: string; reason_label: string | null; reason: string
  pickup: string; dropoff: string; ride_at: string
  amount_zar: number; first_amount_zar: number | null; fare_note: string | null
  fare_corrected_at: string | null; fare_corrected_by_name: string | null
  uber_trip_ref: string | null
  carried_by: CarriedBy; carried_by_note: string | null; charge_owner_name: string | null
  booked_by_name: string | null; booked_at: string
  cancelled_at: string | null; cancel_reason: string | null; cancelled_by_name: string | null
  can_change: boolean
}

export type RideList = {
  rows: Ride[]
  counts: {
    this_month: number; this_month_zar: number
    driver_borne: number; driver_borne_zar: number
    owner_borne: number; owner_borne_zar: number
  }
  spend: { month: string; carried_by: CarriedBy; rides: number; amount_zar: number }[]
  driver_recoverable: boolean
}

export const CARRIED_BY_LABEL: Record<CarriedBy, string> = {
  fleetly: 'Fleetly',
  driver: 'Driver',
  owner: 'Owner',
}

export const CARRIED_BY_TONE: Record<CarriedBy, 'green' | 'red' | 'amber' | 'neutral' | 'brand'> = {
  fleetly: 'neutral',
  driver: 'amber',
  owner: 'brand',
}

/** An http(s) link from the trip reference, or null when it is a plain trip id. */
export function tripLink(ref: string | null): string | null {
  if (!ref) return null
  return /^https?:\/\//i.test(ref.trim()) ? ref.trim() : null
}
